module.exports = __webpack_public_path__ + "static/media/btn_download_pdf.10959825.png";